import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { SiteFooter } from '../components/SiteFooter';
export function Landing() {
  return <div className="flex min-h-screen w-full flex-col bg-white font-sans text-ink" data-id="element-81" data-mp="3kopnmegidilw">
      <SiteHeader data-id="element-82" data-mp="3poanqs7ezx07" />
      <main className="flex flex-1" data-id="element-83" data-mp="3potvjg3cp50i">
        <Hero data-id="element-84" data-mp="3ppvh4ehzt9wh" />
      </main>
      <SiteFooter data-id="element-85" data-mp="3plxx7qnlcebj" />
    </div>;
}